import { DefaultTheme, type Theme } from '@react-navigation/native'
import { Platform } from 'react-native'

export const NavigationLightTheme: Theme = {
  ...DefaultTheme,
  dark: false,
  colors: {
    primary: 'rgb(21, 93, 252)',
    background: 'rgb(255, 255, 255)',
    card: 'rgb(255, 255, 255)',
    text: 'rgb(23, 23, 23)',
    border: 'rgb(229, 231, 235)',
    notification: 'rgb(255, 59, 48)',
  },
}

export const NavigationDarkTheme: Theme = {
  ...DefaultTheme,
  dark: true,
  colors: {
    primary: 'rgb(21, 93, 252)',
    background: 'rgb(18, 18, 18)',
    card: 'rgb(18, 18, 18)',
    text: 'rgb(219, 219, 220)',
    border: 'rgb(229, 231, 235)',
    notification: 'rgb(255, 59, 48)',
  },
}

/** Android SearchView can keep stale text/hint colors after light/dark switch; tie colors to navigation theme. */
export function androidHeaderSearchBarThemeProps(theme: Theme) {
  if (Platform.OS !== 'android') {
    return {}
  }
  return {
    textColor: theme.colors.text,
    headerIconColor: theme.colors.text,
  }
}
